<template>
    <div>
        <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
                :class="[tableClass]"
                @row-click="onRowClick"
                ref="table"
                v-cloak
        >
            <template v-for="name in templatedSlotNames" :slot="name" slot-scope="props">
                <slot :name="name" :row="props.row" />
            </template>
        </v-client-table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';

    Vue.use(ClientTable);

    export default {
        name: 'client-snappy-table',
        components: {ClientTable},
        data() {
            let self = this;
            return {
                options: {
                    texts: {
                        filterPlaceholder:'Search',
                        count: '{count} ' + this.recordType
                    },
                    columnsClasses: this.setColumnClasses(),
                    templates: this.templateMethods,
                    sortable: ['name'],
                    debounce: 250,
                    headings: this.getHeadings(),
                    listColumns: this.filterValues,
                    orderBy: this.defaultOrdering
                },
                params: {}
            };
        },
        methods: {
            onRowClick(event){
                this.handleRowClick(event);
            },
            getHeadings() {
                let headings = {};
                this.columns.map((key, i) => headings[key] = this.headings[i]);
                return headings;
            },
            setColumnClasses() {
                let classes = {};
                this.columns.map((key) => classes[key] = key);
                return classes;
            },
            queryAdapter(params) {
                let orderDirection = params.ascending !== 1 ? 'asc' : 'desc';
                let query = {limit:params.limit, page:params.page, order_by: params.orderBy, order_direction:orderDirection};
                let keys = Object.keys(params.query);

                keys.forEach( (filter) => {
                    if(filter === 'status' || filter === 'groupcontactselected' || filter === 'contacteditgroupmembership') {
                        query['status'] = params.query[filter];
                    } else if(filter === 'email' || filter === 'first_name' || filter === 'last_name' || filter === 'name' || filter === 'contactgroup') {
                        query['query'] = params.query[filter];
                    } else if(filter === 'type') {
                        query['activity_type_id'] = params.query[filter];
                    } else if(filter === 'contact.name') {
                        query['contact'] = params.query[filter];
                    } else if(filter === 'campaign') {
                        query['campaign_id'] = params.query[filter];
                    } else if(filter === 'created_at') {
                        let startDate = new Date(params.query[filter].start);
                        startDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
                        query['start_date'] = startDate;

                        let endDate = new Date(params.query[filter].end);
                        endDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
                        query['end_date'] = endDate;
                    } else {
                        query['query'] = params.query;
                    }
                });

                if( !!this.defaultParams ) {
                    let defaultKeys = Object.keys(this.defaultParams);
                    defaultKeys.forEach( (filter) => {
                        query[filter] = this.defaultParams[filter];
                    });
                }

                return query;
            }
        },
        props: {
            tableData: {
                type: Array,
                required: true
            },
            columns: {
                type: Array,
                required: true
            },
            templateMethods: {
                type: Object,
                required: false
            },
            handleRowClick: {
                type: Function,
                required: false,
                default: () => {
                    return false;
                }
            },
            templatedSlotNames: {
                type: Array,
                required: false,
                default: () => []
            },
            headings: {
                type: Array,
                required: true
            },
            tableClass: {
                type: String,
                required: false,
                default: ''
            },
            defaultOrdering: {
                type: Object,
                required: false,
                default: () => {}
            },
            recordType: {
                type: String,
                required: false,
                default: 'Records'
            }
        }
    }
</script>